module.exports = __webpack_public_path__ + "static/uncovering-memories-from-world-war-ii-b9a063a37dedae09727634efd1f83acd.jpg";